module.exports = __webpack_public_path__ + "img/user-img.976a154b.png";